<template>
  <div class="tagRow">
    <span class="tagRow-tip" v-if="!readonly">（支持最多5个标签,双击标签即可编辑,回车即可保存）</span>
    <edit-tag
      :key="index"
      ref="editTag"
      v-for="(tag,index) in value"
      :value="tag"
      :index="index"
      :size="size"
      :readonly="readonly"
      @edit="onEdit"
      @confirm="onValueChange"
      @close="handleClose" >
    </edit-tag>
    <div v-if="canAdd">
      <confirm-input
        placeholder="请输入标签内容"
        v-if="inputVisible"
        v-model.trim="inputValue"
        ref="saveTagInput"
        size="mini"
        maxlength="10"
        show-word-limit
        @confirm="handleInputConfirm"
        @cancel="handleInputCancel"
      >
      </confirm-input>
      <el-button v-else type="text" icon="el-icon-plus" class="button-new-tag" size="mini" @click="showInput">添加</el-button>
    </div>
  </div>
</template>
<script>
import EditTag from "./editTag.vue";
import ConfirmInput from "./confirmInput.vue";
export default {
  name: "TagRow",
  components: {
    EditTag,
    ConfirmInput
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: 5
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      inputVisible: false,
      inputValue: ""
    };
  },
  computed: {
    canAdd() {
      return !this.readonly && this.value.length < this.maxLength;
    }
  },
  methods: {
    onValueChange(val, index) {
      if (this.value[index] === val) {
        this.$refs.editTag[index].inputVisible = false;
        return;
      }
      const isValid = this.validateInput(val, index);
      if (isValid) {
        this.$emit("change", [
          ...this.value.slice(0, index),
          val,
          ...this.value.slice(index + 1)
        ]);
        this.$refs.editTag[index].inputVisible = false;
      }
    },
    handleClose(tag) {
      const delIndex = this.value.indexOf(tag);
      this.$emit("change", [
        ...this.value.slice(0, delIndex),
        ...this.value.slice(delIndex + 1)
      ]);
    },
    showInput() {
      this.inputValue = "";
      this.inputVisible = true;
      this.onEdit(-1);
      this.$nextTick(_ => {
        const saveTagInput = this.$refs.saveTagInput;
        saveTagInput && saveTagInput.focus();
      });
    },
    onEdit(index) { // -1表示除添加外的输入框取消显示，-2表示全部输入框取消显示
      const editTags = this.$refs.editTag;
      if (editTags) {
        editTags.forEach((e, i) => {
          if (index !== i) {
            e.handleCancel();
          }
        });
      }

      if (index !== -1) {
        this.inputVisible = false;
      }
    },
    handleInputCancel() {
      this.inputVisible = false;
      this.inputValue = "";
    },
    validateInput(inputValue) {
      if (!inputValue) {
        this.$message.error("标签不能为空!");
        return false;
      }

      if (this.value.includes(inputValue)) {
        this.$message.error("标签重复,请重新输入!");
        return false;
      }
      return true;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      const isValid = this.validateInput(inputValue);
      if (isValid) {
        this.$emit("change", [
          ...this.value,
          inputValue
        ]);

        this.inputVisible = false;
      }

    }
  }
};
</script>
<style lang="scss" scoped>
.tagRow{
  display: flex;
  flex-direction: column;
  &-tip{
    font-size: 12px;
    color: #909399;
    line-height: 20px;
  }
}

.button-new-tag {
  margin-left: 10px;
  height: 24px;
  line-height: 1;
  padding-top: 0;
  padding-bottom: 0;
}
</style>